export const colors = {
  heatmap: {
    bad: '#fffd41',
    middle: '#f7e89b',
    good: '#ff7b7b',
    outside: '#d7d7d7',
  },
};
